const headerMenu = document.querySelector('.header-menu');
const navMenu = document.querySelector('.nav-menu__ul');

// Open nav drawer on mouseover

navMenu.addEventListener('mouseover', function(event) {
  const target = event.target;
  const closestParent = target.closest('.nav-menu__li');
  if (target.classList.contains('nav-menu__li') || target.closest('.nav-menu__li')) {
    if (!closestParent.querySelector('.nav-drawer')) return;

    const navDrawers = document.querySelectorAll('.nav-drawer');
    for (const navDrawer of navDrawers) {
      navDrawer.classList.remove('open');
    }

    if (!target.closest('.nav-drawer')) {
      const navInnerDrawers = document.querySelectorAll('.nav-drawer-inner');
      for (const navInnerDrawer of navInnerDrawers) {
        navInnerDrawer.classList.remove('open');
      }
    }
      
    document.querySelector('.nav-drawer-background').classList.add('open');
    closestParent.querySelector('.nav-drawer').classList.add('open');
    closestParent.querySelector('.nav-drawer__ul').classList.add('open');
    this.classList.add('open');
  }
});

// Open nav inner drawer (if available) on drawer link mouseover

navMenu.addEventListener('mouseover', function(event) {
  const target = event.target;
  const closestParent = target.closest('.nav-drawer__li');
  const closeInnerDrawers = function() {
    const navInnerDrawers = document.querySelectorAll('.nav-drawer-inner');
    for (const navInnerDrawer of navInnerDrawers) {
      navInnerDrawer.classList.remove('open');
    }
  }
  if (target.classList.contains('nav-drawer__li') || closestParent) {
    closeInnerDrawers();
    if (!closestParent.querySelector('.nav-drawer-inner')) return;
    
    closestParent.querySelector('.nav-drawer-inner').classList.add('open');
  } else {
    closeInnerDrawers();
    return;
  }
});

// Close all nav drawers on mouseleave

navMenu.addEventListener('mouseleave', function() {
  document.querySelector('.nav-drawer-background').classList.remove('open');

  const navDrawers = document.querySelectorAll('.nav-drawer');
  for (const navDrawer of navDrawers) {
    navDrawer.classList.remove('open');
  }

  const navInnerDrawers = document.querySelectorAll('.nav-drawer-inner');
  for (const navInnerDrawer of navInnerDrawers) {
    navInnerDrawer.classList.remove('open');
  }
  this.classList.remove('open');
});

// Open mobile nav on hamburger click

const hamburgerIcon = document.querySelector('.hamburger-icon-wrapper');

hamburgerIcon.addEventListener('click', function() {
  const navDrawerItems = document.querySelectorAll('.nav-drawer__ul--mobile');
  for (navDrawerItem of navDrawerItems) {
    navDrawerItem.classList.remove('open');
  }
  const navInnerDrawerItems = document.querySelectorAll('.nav-drawer-inner__ul--mobile');
  for (navInnerDrawerItem of navInnerDrawerItems) {
    navInnerDrawerItem.classList.remove('open');
  }

  document.querySelector('.nav-menu__ul--mobile').classList.add('open');
});


// Open mobile nav children menus on link click

headerMenu.addEventListener('click', function(event) {
  const target = event.target;
  const closestParent = target.closest('.nav-menu__li--mobile');
  if (target.classList.contains('nav-menu__li--mobile') || target.closest('.nav-menu__li--mobile')) {
    if (!closestParent.querySelector('.nav-drawer__ul--mobile')) return;
    closestParent.querySelector('.nav-drawer__ul--mobile').classList.add('open');
  }
});

headerMenu.addEventListener('click', function(event) {
  const target = event.target;
  const closestParent = target.closest('.nav-drawer__li--mobile');
  if (target.classList.contains('nav-drawer__li--mobile') || target.closest('.nav-drawer__li--mobile')) {
    if (target.classList.contains('nav-back-btn')) return;
    if (!closestParent.querySelector('.nav-drawer-inner__ul--mobile')) return;
    closestParent.querySelector('.nav-drawer-inner__ul--mobile').classList.add('open');
  }
});

// Return to previous parent menu

headerMenu.addEventListener('click', function(event) {
  const target = event.target;
  const closestParent = target.closest('.nav-drawer__ul--mobile');
  if (target.classList.contains('nav-back-btn') && !target.closest('.nav-drawer-inner__ul--mobile')) {
    closestParent.classList.remove('open');
  }
});

headerMenu.addEventListener('click', function(event) {
  const target = event.target;
  const closestParent = target.closest('.nav-drawer-inner__ul--mobile');
  if (target.classList.contains('nav-back-btn') && target.closest('.nav-drawer-inner__ul--mobile')) {
    closestParent.classList.remove('open');
  }
});

// Close mobile nav on click

document.body.addEventListener('click', function(event) {
  const target = event.target;
  const closestParent = target.closest('.header-menu');
  if (!closestParent || target.classList.contains('nav-close-btn-wrapper')) {
    headerMenu.querySelector('.nav-menu__ul--mobile').classList.remove('open');
  }
});

// Hide nav on scroll

let oldScrollPosition = 0;
let scrollPosition;
let slideOutPosition = 250;
const siteNavWrapper = document.querySelector('.shopify-header');

window.addEventListener('scroll', function() { // Run function every time you scroll on the page

  scrollPosition = window.pageYOffset; // Get current scroll position

  if (scrollPosition > slideOutPosition) { // If the user is scrolling past the break point
    if (scrollPosition < oldScrollPosition) { // If user is scrolling up
      siteNavWrapper.classList.remove('close');
    } else { // If user is scrolling down
      siteNavWrapper.classList.add('close');
    }
  } else { // If the user is scrolling above the break point
    siteNavWrapper.classList.remove('close'); // Show the nav bar, and remove color
  }

  if (scrollPosition < 500) {
    document.querySelector('.header-wrapper').classList.add('transparent');
  } else {
    document.querySelector('.header-wrapper').classList.remove('transparent');
  }

  oldScrollPosition = scrollPosition; // Save scrollPosition as past scroll state (to know if user scrolled up)

});

// Open search form on icon click

const searchIcon = document.querySelector('.header-icon.icon-search');
const headerSection = document.querySelector('.header-search')

searchIcon.addEventListener('click', function() {
  headerSection.classList.add('open');
  headerSection.querySelector('.header-search-input').focus();
});

// Remove search form on close icon and click out

document.body.addEventListener('click', function(event) {
  target = event.target;
  if (!target.classList.contains('header-icon')) {
    if (target.classList.contains('header-search') || target.closest('.header-search') && !target.classList.contains('header-search-form-icon-close')) {
      return;
    } else {
      headerSection.classList.remove('open');
      headerSection.querySelector('.header-search-input').blur();
    };

  };

});


/*
document.querySelectorAll('.nav-menu__link--mobile').forEach(function(el) {
  el.addEventListener('click', function(e) {
    e.preventDefault();
  });
});
*/